import { render, staticRenderFns } from "./NavButtons.vue?vue&type=template&id=bdac339a&scoped=true"
import script from "./NavButtons.vue?vue&type=script&lang=ts"
export * from "./NavButtons.vue?vue&type=script&lang=ts"
import style0 from "./NavButtons.vue?vue&type=style&index=0&id=bdac339a&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdac339a",
  null
  
)

export default component.exports